<script setup lang="ts">
import AlarmReportTotalizerCard from './AlarmReportTotalizerCard.vue'

import { IAlarmReportMetrics } from '@/interfaces/stores/alarm'

import { formatAlarmMetricsTotalizers } from '@/utils/components/alarm/alarm-report-totalizers'

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  alarmReportMetrics: IAlarmReportMetrics
}>()

const alarmReportTotalizers = computed(() => formatAlarmMetricsTotalizers(props.alarmReportMetrics))
</script>

<template>
  <section
    class="flex flex-col gap-4 border border-stroke bg-gray-2 p-4 lg:p-6"
    style="border-top-width: 3px; border-top-color: #123add">
    <header>
      <h2 class="font-satoshi text-title-xsm2 font-bold text-black">
        {{ t('alarm_report.body.result.sections.summary.title') }}
      </h2>
    </header>

    <div class="grid grid-cols-1 items-stretch gap-4 sm:grid-cols-2 lg:grid-cols-4">
      <AlarmReportTotalizerCard
        v-for="(item, index) in alarmReportTotalizers"
        :key="index"
        :value="item.value"
        :label="item.label" />
    </div>
  </section>
</template>
